const getWindow_ = function() {
    return window
}

const webtrekkConfig = {
    trackId:
        window.location.hostname === 'login.creditreform.de'
            ? '195357560818821'
            : '465631094018133',
    trackDomain: 'webmet.creditreform.de',
    domain: window.location.hostname,
    cookie: '3'
}

const WebtrekkVue = function() {
    this.window_ = null

    let self_ = this
    let callStack = []

    const _init = function() {
        self_.window_ = getWindow_()
    }

    const hasConsentForWebtrekk = function(cmpSettings) {
        if (
            cmpSettings &&
            cmpSettings.services &&
            cmpSettings.services.length
        ) {
            const wtConsent = cmpSettings.services.find(function(service) {
                return service.id === 'Ouzxu26Rv'
            })
            return wtConsent && wtConsent.status === true
        }
        return false
    }

    const appendPageTrackingParameters = function(data = {}) {
        data.parameter = Object.assign({}, data.parameter, {
            108: 'meinecreditreform',
            109: 'de'
        })
        data.category = Object.assign({}, data.category, {
            1: 'meinecreditreform',
            3: 'user-management',
            4: 'de'
        })

        return data
    }

    const appendActionTrackingParameters = function(data = {}) {
        data.parameter = Object.assign({}, data.parameter, {
            20: 'meinecreditreform',
            21: 'de'
        })

        return data
    }

    this.executePushTracking = function(cmpSettings, call) {
        if (hasConsentForWebtrekk(cmpSettings)) {
            console.log(
                '[WebtrekkVue] User consent for Webtrekk tracking given'
            )
            self_.window_.wtSmart = self_.window_.wtSmart || []
            self_.window_.wtSmart.push(call)
        } else {
            console.log(
                '[WebtrekkVue] Intercepted Webtrekk tracking due to missing user consent'
            )
        }
    }

    this.getCmpSettings = function(maxWaitingTime = 60000) {
        // 60 Seconds
        return new Promise(function(resolve, reject) {
            function fetchCmpSettings() {
                let cmpSettings = localStorage.getItem('uc_settings')
                if (cmpSettings !== null && cmpSettings?.length) {
                    try {
                        cmpSettings = JSON.parse(cmpSettings)
                        console.dir(cmpSettings)
                    } catch (e) {
                        console.log(
                            'something went wrong from src/plugins/webtrekk/WebTrekk.js'
                        )
                    }
                }
                return cmpSettings
            }

            function waitForCmpSettings(timeout = 250, timeElapsed = 0) {
                const cmpSettings = fetchCmpSettings()
                if (hasConsentForWebtrekk(cmpSettings)) {
                    resolve(cmpSettings)
                } else if (timeElapsed >= maxWaitingTime) {
                    reject(null)
                } else {
                    setTimeout(function() {
                        waitForCmpSettings(timeout * 2, timeElapsed + timeout)
                    }, timeout)
                }
            }

            waitForCmpSettings()
        })
    }

    this.pushTracking = function(call) {
        if (this.window_ === null) {
            _init()
        }

        callStack.push(call)

        this.getCmpSettings()
            .then(function(cmpSettings) {
                callStack.forEach(function(callItem) {
                    self_.executePushTracking(cmpSettings, callItem)
                })
                callStack = []
            })
            .catch(function() {
                console.log(
                    '[WebtrekkVue] Intercepted Webtrekk tracking due to missing user consent'
                )
            })
    }

    this.init = function() {
        this.pushTracking(function(pix) {
            pix.init.set(webtrekkConfig)
            pix.advanced.set({ forceOldEverId: true })
        })
    }

    this.page = function(name = '', data = {}, lang = 'de_DE') {
        name = `${lang}.benutzerverwaltung_creditreform_de.${name}`
        data = appendPageTrackingParameters(data)
        this.pushTracking(function(pix) {
            pix.page.data.set(name, data)
        })
    }

    this.action = function(data = {}) {
        data = appendActionTrackingParameters(data)
        this.pushTracking(function(pix) {
            pix.action.data.set(data)
        })
    }

    this.track = function() {
        this.pushTracking(function(pix) {
            pix.track()
        })
    }

    this.trackPage = function() {
        this.pushTracking(function(pix) {
            pix.trackPage()
        })
    }

    this.trackAction = function() {
        this.pushTracking(function(pix) {
            pix.trackAction()
        })
    }
}

const WebTrekk = new WebtrekkVue()
WebTrekk.init()
export default WebTrekk
